import type { ReactNode } from "react";

interface PageShellProps {
  /** app (défaut) = halo+grain, max-w-md md:max-w-5xl, cascade home-stage ;
      narrow = idem mais max-w-md seul ; reading = max-w-2xl SANS halo/grain/cascade. */
  width?: "app" | "narrow" | "reading";
  /** Centre verticalement en desktop (SignIn). */
  center?: boolean;
  children: ReactNode;
}

// Conteneur <main> canonique (DS §6.8). `app`/`narrow` portent le halo de
// marque, le grain et la cascade d'entrée (home-stage) ; `reading` (pages
// légales) privilégie la lecture : colonne max-w-2xl, sans halo ni cascade.
// Classes en littéral (Tailwind v4 ne génère que le littéral).
const MAIN_CLASSES = {
  app: "brand-halo grain mx-auto flex max-w-md md:max-w-5xl flex-col p-5 md:p-8",
  narrow: "brand-halo grain mx-auto flex max-w-md flex-col p-5 md:p-8",
  reading: "mx-auto flex max-w-2xl flex-col p-5 md:p-8",
} as const;

export function PageShell({ width = "app", center = false, children }: PageShellProps) {
  const centerClasses = center ? " md:min-h-dvh md:justify-center" : "";
  if (width === "reading") {
    return <main className={MAIN_CLASSES.reading + centerClasses}>{children}</main>;
  }
  return (
    <main className={MAIN_CLASSES[width] + centerClasses}>
      <div className="home-stage flex flex-col gap-6">{children}</div>
    </main>
  );
}
